import React, { useMemo } from 'react';
import LazyLoad from 'react-lazyload';
import { number } from 'prop-types';
import useLanguageCode from 'hooks/useLanguageCode';
import { checkLinkAndAppendLanguage } from 'utils/localization';
import { FormattedMessage } from 'react-intl';
import * as styles from './styles/styles.module.scss';
import logoPro from './logo_pro.png';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { DESKTOP_BREAKPOINT } from '../../../utils/constants/breakpoints';
import useUser from 'hooks/useUser';
import useFeatureFlags from 'hooks/useFeatureFlags';

const BG_IMAGE_BASE = 'https://cdn-assets.alltrails.com/assets/images/homepage/pro_upsell_no_auth/';

const {
  strings: {
    HOME_PAGE: {
      PRO_UPSELL: { STAY_ON_TRACK, NO_CELL_SERVICE }
    }
  }
} = StringConstantsMixin;

const ProUpsellNoAuth = ({ windowWidth }) => {
  const featureFlags = useFeatureFlags();
  const languageCode = useLanguageCode();
  const user = useUser();

  const featuresContainerStyle = useMemo(() => {
    const isDesktop = windowWidth && windowWidth >= DESKTOP_BREAKPOINT;

    if (!isDesktop) {
      return {};
    }

    const fileName = `bg_desktop_${languageCode}.png`;
    const backgroundImageUrl = `${BG_IMAGE_BASE}${fileName}`;

    return {
      backgroundImage: `url(${backgroundImageUrl})`
    };
  }, [windowWidth]);

  const upperContainerStyle = {
    backgroundImage: `url(${BG_IMAGE_BASE}bg_mobile_${languageCode}.png)`
  };

  return (
    <div className={styles.container}>
      <LazyLoad>
        <div style={upperContainerStyle} className={styles.upperContainer} />
      </LazyLoad>
      <div style={featuresContainerStyle} className={styles.contentContainer}>
        <LazyLoad>
          <img className={styles.logoProImage} src={logoPro} alt="" />
        </LazyLoad>
        <h2 className={styles.title}>{STAY_ON_TRACK}</h2>
        <p className={styles.text}>{NO_CELL_SERVICE}</p>
        <a href={checkLinkAndAppendLanguage('/pro?ref=homepage_pro_proupsellnoauth')} className={styles.buyLink}>
        {(!user || user.isPromoEligible) && featureFlags.sevenDayTrial ? (
            <FormattedMessage defaultMessage="Try Pro for Free" />
          ) : (
            <FormattedMessage defaultMessage="Buy Pro" />
          )}
        </a>
      </div>
    </div>
  );
};

ProUpsellNoAuth.propTypes = {
  windowWidth: number
};

ProUpsellNoAuth.defaultProps = {
  windowWidth: null
};

export default ProUpsellNoAuth;
